import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { SwotProvider } from './context/SwotContext';
import SwotDashboard from './components/SwotDashboard';
import './App.css';

function App() {
  return (
    <SwotProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
          <Routes>
            <Route path="/" element={<SwotDashboard />} />
          </Routes>
        </div>
      </Router>
    </SwotProvider>
  );
}

export default App;